export function loadNewPaymentsOptions(data = null) {
  let count = 5;
  const success = () => {
    if (data) {
      if (window.initPayment) {
        window.initPayment(data);
      } else {
        setTimeout(() => {
          success();
        }, 500);
      }
    }
  };
  const error = (err, scriptTag, callback) => {
    count--;
    console.trace(err);
    //   pushToNewrelic('serviceApp=hotelsMwebPayment&paymentv2failed=true');
    scriptTag.parentNode.removeChild(scriptTag);
    if (count) {
      callback();
    }
  };
  function loadJS() {
    const jsElm = document.createElement('script');
    jsElm.type = 'application/javascript';
    jsElm.src = `${__ENV_CONFIG__.GOIBIBO}/mudra/dist/loadPayments.js?cb=${Math.random()}`;
    jsElm.onload = success;
    jsElm.onerror = () => {
      error('payments failed', jsElm, loadJS);
    };
    document.body.appendChild(jsElm);
  }
  loadJS();
}
